import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const TopVehiclesChart = ({ 
  data, 
  dataKey, 
  color = "#0F172A", 
  height = 300 
}) => (
  <ResponsiveContainer width="100%" height={height}>
    <BarChart data={data}>
      <XAxis dataKey="patente" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Bar dataKey={dataKey} fill={color} radius={[8, 8, 0, 0]} />
    </BarChart>
  </ResponsiveContainer>
);

export default TopVehiclesChart;
